class EvanhealyApp {
    constructor(type) {
        this.breakpoint = window.matchMedia('(min-width:750px)');
        this.breakpoint.addListener(this.breakpointCheck.bind(this));
        this.breadcrumbKey = 'evanhealy_last_collection_bc';
        this.pdpSwipers = [];
        this.mobileSwipers = [];
        this.type = type;
        lazyframe(".lazyframe");
        Shopify.theme.currencyConverter.init();
        switch(type) {
            case 'pdp':
                this.initPdp();
                break;
            case 'plp':
                this.initPlp();
                break;
            default:
                console.error('Unknown EvanhealyApp type');
                break;
        }
    }

    initPlp() {
        var interval = null,
            $breadcrumbs = null,
            $categoryBreadcrumb = null;

        interval = setInterval(() => {
            $breadcrumbs = document.getElementById('breadcrumbs');
            if($breadcrumbs) {
                clearInterval(interval);
                $categoryBreadcrumb = $breadcrumbs.querySelector('[data-breadcrumb-collection]');
                if($categoryBreadcrumb) {
                    this._save(this.breadcrumbKey,btoa($categoryBreadcrumb.innerHTML));
                }
            }
        },1000);

    }

    initPdp() {
        var interval = null,
            $pwzrswiper = null,
            $breadcrumbs = null,
            $categoryAllBreadcrumb = null,
            breadcrumbsInterval = null,
            $productMediaW = document.querySelector('.product__media-wrapper'),
            $stickerHolder = $productMediaW.querySelector('.thumbnail-sticker'),
            $categoryBreadcrumb = null;

        if($stickerHolder) {
            interval = setInterval(() => {
                $pwzrswiper = document.getElementById('pwzrswiper-slide-0');
                if($pwzrswiper) {
                    clearInterval(interval);
                    $pwzrswiper.appendChild($stickerHolder);
                }
            },1000);
        }

        document.body.addEventListener('productRecommendationsLoaded', (event) => {
            this.createPdpSwipers();
        });

        try {
            breadcrumbsInterval = setInterval(() => {
                $breadcrumbs = document.getElementById('breadcrumbs');
                if($breadcrumbs) {
                    clearInterval(breadcrumbsInterval);
                    $categoryAllBreadcrumb = $breadcrumbs.querySelector('[data-breadcrumb-all]');
                    if($categoryAllBreadcrumb) {
                        $categoryBreadcrumb = this._get(this.breadcrumbKey);
                        if($categoryBreadcrumb) {
                            $categoryBreadcrumb = atob($categoryBreadcrumb);
                            var $categoryBreadcrumbParent = document.createElement('li');
                            $categoryBreadcrumbParent.setAttribute('data-breadcrumb-collection','');
                            $categoryBreadcrumbParent.innerHTML = $categoryBreadcrumb;
                            $categoryAllBreadcrumb.after($categoryBreadcrumbParent);
                        }
                    }
                }
            },1000);

        } catch (e) {

        }
    }

    createPdpSwipers() {
        const $pdpSwipers = document.querySelectorAll('.product-recommendations-grid:not(.swiper-initialized)');
        if($pdpSwipers && $pdpSwipers.length > 0) {
            $pdpSwipers.forEach(($pdpSwiper) => {
                const pdpSwiper = new Swiper($pdpSwiper, {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                    pagination: false,
                    navigation: false,
                    createElements: true,
                    breakpoints: {
                        750: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 30
                        }
                    },
                });
                this.pdpSwipers.push(pdpSwiper);
            });
        }
    }

    createMobileSwipers() {

    }

    _save(key,value) {
        localStorage.setItem(key, value);
    }

    _get(key) {
        return localStorage.getItem(key);
    }

    _remove(key) {
        localStorage.removeItem(key);
    }

    breakpointCheck() {
        if (this.breakpoint && this.breakpoint.matches === true ) {
            if (this.mobileSwipers.length > 0) {
                this.mobileSwipers.forEach((mobileSwiper) => {
                    mobileSwiper.destroy(true, true);
                });
                this.mobileSwipers = [];
            }
        } else if (this.breakpoint.matches === false) {
            this.createMobileSwipers();
        }
    }
}
